export const environment = {
  endpoint: 'https://beta.api.limpiezaespinarlopez.com/',
  production: false
};
